import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LoggingService } from "./logging.service";

export function convertArrayToDictionary(items: any[], labelProperty: string, valueProperty: string, includeEmptyValue: boolean = false): any {
  let dictionary: any = {};
  if (includeEmptyValue) {
    dictionary[''] = '';
  }
  items.forEach((item: any) => {
    dictionary[item[labelProperty]] = item[valueProperty];
  });
  return dictionary;
}

export const EmptyGuid = "00000000-0000-0000-0000-000000000000";

export function getDistinct<T, K extends keyof T>(data: T[], property: K): T[K][] {
  const allValues = data.reduce((values: T[K][], current) => {
    if (current[property]) {
      values.push(current[property]);
    }
    return values;
  }, []);

  return [...new Set(allValues)];
}

@Injectable()
export class UtilityService {
  constructor(
    private http: HttpClient,
    private loggingService: LoggingService
  ) {
  }

  public generateGuid(): Observable<string> {
    return this.http.get<string>('/api/Utilities/generate-guid/');
  }
}
